import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignaturePad } from './component/angular2-signaturepad.component';
import { ImageDrawingComponent } from './ngx-image-drawing/image-drawing.component';

@NgModule({
  declarations: [ImageDrawingComponent, SignaturePad],
  imports: [CommonModule],
  exports: [SignaturePad, ImageDrawingComponent]
})
export class SharedModule { }